/** Checks if a the input is an object (considers if object is null or an array) */
export const isObject = (object: unknown) => typeof object === "object" && object !== null && !Array.isArray(object);
